<app-menu>
  <div class="desktop">
    <app-voltar class="back" />
    <div class="header">
      <app-titulo
        [text]="isEditMode ? 'Editar usuário' : 'Cadastrar usuário'"
      ></app-titulo>
    </div>
    <form #criarUsuarioForm="ngForm" class="form">
      <app-input
        type="text"
        width="100%"
        label="Nome do usuário"
        name="nomeUsuario"
        placeholder="Nome"
        [requiredInput]="true"
        [(ngModel)]="form.nomeUsuario"
      ></app-input>
      <app-input
        type="text"
        width="100%"
        label="E-mail"
        name="email"
        placeholder="exemplo@exemplo.com"
        [requiredInput]="true"
        [(ngModel)]="form.email"
      ></app-input>
      <app-input
        type="text"
        width="100%"
        label="Telefone / Celular"
        name="telefone"
        placeholder="(00) 0000-0000"
        mask="(00) 0000-0000||(00) 00000-0000"
        [(ngModel)]="form._telefone"
      ></app-input>
      <app-input
        label="Perfil"
        type="select"
        name="perfil"
        [requiredInput]="true"
        [selectData]="perfilOptions"
        [(ngModel)]="form.perfil"
        (ngModelChange)="onChangeSelect($event)"
      ></app-input>
    </form>
    <div class="form-button">
      <app-botao
        width="100%"
        [text]="isEditMode ? 'Editar' : 'Criar'"
        (click)="cadastrarOuEditarUsuario()"
        [disabled]="validarForm() ? false : true"
        *ngIf="permission === 1"
      ></app-botao>
    </div>
  </div>
</app-menu>

<app-loader *ngIf="loader" />
